<template>
    <div class="shipDetail-destination" v-if="destinations&&destinations.length>0">
        <div class="shipDetail-destination-title">
            <div class="shipDetail-destination-titleLine"></div>
            <div class="shipDetail-destination-titleTxt">{{ship.shipCNName}}前往的目的地</div>
        </div>
        <div class="shipDetail-destination-container" :style="containerStyle">
            <div class="destinationList-item" v-for="(destination, i) in destinations" :key="('destination_'+i)">
                <div class="destinationList-itemPic">
                    <img :src="destination.imageUrl">
                </div>
                <div class="destinationList-itemTxt">
                    <p class="destinationList-desName">{{destination.harborCNName}}</p>
                    <div class="destinationList-seeCrusieBtn seeCrusieBtn">
                        <a class="external">查看航线</a>
                    </div>
                </div>
                <a class="external hold-link" @click="goToCruiseSearch(destination)">
                </a>
            </div>
        </div>

        <div class="shipDetail-destination-showMore" @click="isShowMore=!isShowMore">
            <span class="destination-showMoreBtn">
                <span class="">{{isShowMore ? "收起": "展开更多"}}</span>
                <span class="destination-showMoreArrow" :class="{ active: isShowMore}" aria-hidden="true"></span>
            </span>
        </div>
    </div>

</template>

<script>
export default {
    name: "ShipDestinations",
    props: {
        destinations: {
            type: Array,
            default () {
                return []
            }
        },
        ship: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            isShowMore: false
        }
    },
    methods: {
        goToCruiseSearch (destination) {
            if (destination.isRow) {
                location.href = `${process.env.VUE_APP_TUI_URL}/Cruise/Search?destinationCodes=${destination.harborCode}` 
            } else {
                return this.$router.push({
                    name: "CruiseSearch",
                    query: {
                        destinationCodes: destination.harborCode
                    }
                })
            }
        }
    },
    computed: {
        containerStyle () {
            return this.isShowMore ? { 'height': 'auto'} : {}
        }
    }
}
</script>

<style lang="less" scoped>
.shipDetail-destination{
    margin-top: 9px;
    background-color: #fff;
    .shipDetail-destination-title {
        padding: 27px 0;
        position: relative;
        .shipDetail-destination-titleLine {
            height: 1px;
            background-color: #fecc46;
        }
        .shipDetail-destination-titleTxt {
            width: 158px;
            position: absolute;
            top: 18px;
            left: 50%;
            margin-left: -79px;
            padding: 0 1.867%;
            background-color: #fff;
            text-align: center;
            color: #061556;
            font-size: 13px;
        }
        
    }
    .shipDetail-destination-container {
        overflow: hidden;
        width: 351px;
        height: 122.03px;
        margin: auto;
        .destinationList-item {
            float: left;
            position: relative;
            margin-bottom: 1.426%;
            width: 113.36px;
            height: 117.28px;
            overflow: hidden;
            .destinationList-itemPic {
                width: 100%;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .destinationList-itemTxt {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 100%;
                text-align: center;
                background-color: rgba(0,0,0,.5);
                p {
                    margin: 0;
                }
                .destinationList-desName {
                    color: #fff;
                    font-size: 13px;
                    margin-top: 26% !important;
                    margin-bottom: 6% !important;
                }
                .destinationList-seeCrusieBtn a {
                    color: #f9b811;
                    font-size: 9px;
                    padding: 1.75% 5.24%;
                    border-radius: 4px;
                    border: 1px solid #f9b811;
                    display: inline-block;
                }
            }
            .hold-link {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
        .destinationList-item:nth-child(3n+2) {
            margin-left: 1.426%;
            margin-right: 1.426%;
        }
    }

    .shipDetail-destination-showMore {
        margin-top: 9px;
        padding-bottom: 12px;
        text-align: center;
        .destination-showMoreBtn {
            color: #333;
            font-size: 11px;
            .destination-showMoreArrow {
                display: inline-block;
                width: 7px;
                height: 7px;
                border-right: 1px solid #fecc47;
                border-bottom: 1px solid #fecc47;
                transform: rotate(45deg);
                -ms-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                -o-transform: rotate(45deg);
                vertical-align: 2px;
                margin-left: 4px;
            }
            .destination-showMoreArrow.active {
                transform: rotate(225deg);
                -ms-transform: rotate(225deg);
                -moz-transform: rotate(225deg);
                -webkit-transform: rotate(225deg);
                -o-transform: rotate(225deg);
                vertical-align: -1px;
            }
        }
    }
}
</style>
